export const PROGRAM_INSTANCE_QUERY_KEY = 'programInstance';
